// extracted by mini-css-extract-plugin
module.exports = {"container":"Section1-module--container--3SQWF","centered":"Section1-module--centered--RsN3g","title":"Section1-module--title--3ZBWv"};